export default __webpack_public_path__ + "static/media/bootstrap-icon.0134ffb5.svg";